import styles from './CatalogCategoryPage.module.css';
import { Header } from '../../../components/Header/Header';
import { useSearchParams } from 'react-router-dom';
import { useAllItemsQuery } from '../../../store/api/item.api';
import { MinSliderCard } from '../../../components/Slider/minSliderCard/minSliderCard';

export const CatalogCategoryPage = () => {

	const [searchParams] = useSearchParams();
	const type = searchParams.get('type');
	const schema = sessionStorage.getItem('schema') || '';

	const { data: itemsData = [], isLoading: isItemsLoading } = useAllItemsQuery({ schema, params: { customLimit: 200 } });

	const filteredItems = itemsData.filter(item => {
		if (type === "Распродажа") {
			return item.price_disc || item.P2_price_disc;
		}
		if (type === "До 500") {
			let price

			if (!schema){
				price = item.price_disc_sub || item.price_disc || item.price;
			} else {
				price = item.P2_price_disc || item.P2_price;
			}
			return price <= 500;
		}
		if (type === "До 1000") {
			let price

			if (!schema) {
				price = item.price_disc_sub || item.price_disc || item.price;
			} else {
				price = item.P2_price_disc || item.P2_price;
			}
			return price >= 500 && price <= 1000;
		}
		if (type === "Полностью на русском") {
			return item.lang === "Полностью на русском";
		}
		return false;
	});

	return (
		<div className={styles.main}>
			<Header />
			<div className={styles.header}>
				<div className={styles.title_block}>
					<h2>{type}</h2>
				</div>
			</div>

			<div className={`result_container`}>
				{isItemsLoading ? (
					<p>Загрузка...</p>
				) : (
					<>
						{filteredItems.length === 0 && (
							<p>Ничего не найдено</p>
						)}

						{filteredItems.map(item => (
							<MinSliderCard
								from='categories'
								key={item.id}
								title={item.title}
								price={item.price}
								price_disc={item.min_price || item.price_disc}
								devices={item.devices}
								lang={item.lang}
								img={item.img}
								itemId={item.id}
								buyBtn={true}
								category={'item'}
								style={{height: 353}}
							/>
						))}
					</>
				)}
			</div>
		</div>
	);
};
